import React from 'react';
import Highlights from '../Services/HighlightsDe'
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSectionServices'
import Hero from '../HeroContDe'
import HeroCorp from '../HeroCorp'
import Footer from '../../Footer/FooterDe';

function Products(){
    return (
        <div>
            <Hero/>
            <Highlights />
            <Footer/>
{/*            
            <HeroCorp/> */}
            
        </div>
    );
}

export default Products;
